import { DefaultButton, PrimaryButton, TextField } from "@fluentui/react";
import React, { useEffect } from "react";
import NextPreviousSection from "../NextPreviousSection.jsx/NextPreviousSection";
import ContactDetailsRow from "./ContactDetialsRow";
import { t } from "i18next";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";

const ContactDetailsSection = (props) => {

    return (
        <>
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                marginBottom: "30px",
              }}
            >
              {t("hospital.contact-details")}
            </p>
          </section>
          <ContactDetailsRow
              id="sectionA"
              headerName={t("string-literals.first-contact-details")}
              name="contact1"
              values={props.values.contact1}
              handleBlur={props.handleBlur}
              handleChange={props.handleChange}
              // errors={props.errors}
              // touched={props.touched}
              errorState={props.errorContactState?.contact1}
              checkError={props.errorContactState?.errorState}
              state={props.state}
              action = {props.action === ACTIONS.EDIT && props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm ? ACTIONS.VIEW : props.action}
              editConfigurationSetting={props.editConfigurationSetting}

          />
          {((props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT && !props.editConfigurationSetting) || (props.action === ACTIONS.VIEW && props.values.contact2.name)) &&
           <ContactDetailsRow
              id="sectionB"
              headerName={t("string-literals.second-contact-details")}
              name="contact2"
              values={props.values.contact2}
              handleBlur={props.handleBlur}
              handleChange={props.handleChange}
              errorState={props.errorContactState?.contact2}
              checkError={props.errorContactState?.errorState}
              state={props.state}
              action = {props.action === ACTIONS.EDIT && props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm ? ACTIONS.VIEW : props.action}
          />
          }
          {((props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT && !props.editConfigurationSetting) || (props.action === ACTIONS.VIEW && props.values.contact3.name)) &&
          <ContactDetailsRow
              id="sectionC"
              headerName={t("string-literals.third-contact-details")}
              name="contact3"
              values={props.values.contact3}
              handleBlur={props.handleBlur}
              handleChange={props.handleChange}
              errorState={props.errorContactState?.contact3}
              checkError={props.errorContactState?.errorState}
              state={props.state}
              action = {props.action === ACTIONS.EDIT && props.roles[0] === USERTYPES.FIRMADMIN && !props.ownFirm ? ACTIONS.VIEW : props.action}
          />
          }
        </div>
      </>
    )
};

export default ContactDetailsSection;